// extracted by mini-css-extract-plugin
export var button = "_c5-4";
export var hasDarkBackground = "_c5-7";
export var hasLightBackground = "_c5-6";
export var iconWrapper = "_c5-0";
export var large = "_c5-2";
export var medium = "_c5-1";
export var small = "_c5-5";
export var xsmall = "_c5-3";